/**
 * Automy.Core.Enums.Reporting.Operations.PowerBiDatasetRefreshStatus
 * JSON `lastStatus` is integer unless a converter is added. Tokens match Power BI REST.
 */
export default Object.freeze({
  Unknown: 1,
  NotStarted: 2,
  InProgress: 3,
  Completed: 4,
  Failed: 5,
  Disabled: 6,
  Cancelled: 7,
});
